<template>
  <div>
    <div class="background d-none">
      <div class="ipad-bg d-none d-sm-block d-lg-none">
        <svg viewBox="0 0 768 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M192.5 94C182 94 0.5 0.5 0.5 0.5V100H768V26H461C461 26 203 94 192.5 94Z" fill="white" />
        </svg>
      </div>
      <svg class="d-none d-lg-block" width="1920" height="816" viewBox="0 0 1920 816" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1920 0V637L1823.33 706.711C1818.57 710.149 1812.84 712 1806.96 712H708.528C706.185 712 703.852 712.294 701.582 712.875L304.997 814.44C298.544 816.092 291.714 815.39 285.733 812.46L-1 672V0H1920Z" fill="url(#paint0_desktop_linear)" />
        <defs>
          <linearGradient
            id="paint0_desktop_linear"
            x1="-0.998721"
            y1="361.009"
            x2="2116"
            y2="-74.9926"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#0161A7" />
            <stop offset="1" stop-color="#00B9F3" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="d-none">
      <svg class="figure-1" width="284" height="429" viewBox="0 0 284 429" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.2617 2.55196L-138.863 202.755L27.7826 389.579L195.026 197.756L31.2617 2.55196Z" fill="url(#paint9_linear)" fill-opacity="0.2" /><path d="M187.693 124.386L89.8569 239.159L185.681 346.252L281.859 236.283L187.693 124.386Z" fill="url(#paint10_linear)" fill-opacity="0.2" /><path d="M124.31 277.554L58.5371 354.713L122.957 426.709L191.768 352.78L124.31 277.554Z" stroke="#C4C4C4" stroke-opacity="0.7" /><path d="M162.002 66.2519L122.846 111.5L160.349 156.932L198.031 111.986L162.002 66.2519Z" stroke="#C4C4C4" stroke-opacity="0.7" />
        <defs>
          <linearGradient
            id="paint9_linear"
            x1="57.4167"
            y1="196.275" x2="-61.6097" y2="243.797" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#6BE3B1" />
          </linearGradient>
          <linearGradient
            id="paint10_linear"
            x1="202.727" y1="235.438" x2="134.337" y2="262.826" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#0B8FC7" />
            <stop offset="1" stop-color="#8280F8" />
          </linearGradient>
        </defs>
      </svg>
      <svg class="figure-2" width="333" height="524" viewBox="0 0 333 524" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M153 246L169 227.106L153 209" stroke="white" stroke-width="4" /><path d="M238.324 121.753L398.879 310.695L241.607 487.01L83.7712 305.976L238.324 121.753Z" fill="url(#paint8_linear)" fill-opacity="0.2" /><path d="M90.6929 236.734L183.025 345.05L92.5914 446.119L1.8228 342.336L90.6929 236.734Z" fill="url(#paint6_linear)" fill-opacity="0.2" /><path d="M150.513 381.287L212.586 454.105L151.789 522.052L86.8484 452.281L150.513 381.287Z" stroke="#C4C4C4" stroke-opacity="0.7" /><path d="M114.94 181.869L151.894 224.572L116.499 267.448L80.9374 225.03L114.94 181.869Z" stroke="#C4C4C4" stroke-opacity="0.7" /><path d="M298.055 2.81541L419.978 145.844L300.562 279.303L180.705 142.261L298.055 2.81541Z" fill="url(#paint7_linear)" fill-opacity="0.2" />
        <defs>
          <linearGradient
            id="paint8_linear"
            x1="213.64" y1="304.58" x2="325.971" y2="349.428" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#6BE3B1" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="76.5037" y1="341.539" x2="141.047" y2="367.386" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#0B8FC7" />
            <stop offset="1" stop-color="#8280F8" />
          </linearGradient>
          <linearGradient
            id="paint7_linear"
            x1="237.238" y1="164.021" x2="384.018" y2="82.0531" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#8280F8" />
          </linearGradient>
        </defs>
      </svg>
      <svg class="figure-3" width="206" height="394" viewBox="0 0 206 394" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M166.8 145.211L126.307 192.004L165.091 238.987L204.059 192.507L166.8 145.211Z" stroke="#C4C4C4" stroke-opacity="0.7" /><path d="M49.7213 101.029L-78.1998 251.567L47.1053 392.045L172.86 247.808L49.7213 101.029Z" fill="url(#paint12_linear)" fill-opacity="0.2" /><path d="M101.68 1.79523L4.53945 115.752L99.6828 222.085L195.178 112.897L101.68 1.79523Z" fill="url(#paint13_linear)" fill-opacity="0.2" />
        <defs>
          <linearGradient
            id="paint12_linear"
            x1="69.3879" y1="246.695" x2="-20.1111" y2="282.428" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#6BE3B1" />
          </linearGradient>
          <linearGradient
            id="paint13_linear"
            x1="150.136" y1="130.234" x2="33.19" y2="64.9272" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#8280F8" />
          </linearGradient>
        </defs>
      </svg>
      <svg class="figure-4" width="336" height="510" viewBox="0 0 336 510" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M149.725 150.205L2.71089 323.212L146.719 484.657L291.243 318.892L149.725 150.205Z" fill="url(#paint14_linear)" fill-opacity="0.2" /><path d="M295.56 252.864L211.015 352.045L293.822 444.59L376.935 349.56L295.56 252.864Z" fill="url(#paint15_linear)" fill-opacity="0.2" /><path d="M236.789 379.225L179.951 445.902L235.62 508.118L295.084 444.232L236.789 379.225Z" stroke="#C4C4C4" stroke-opacity="0.7" /><path d="M273.36 202.627L239.523 241.728L271.932 280.988L304.494 242.148L273.36 202.627Z" stroke="#C4C4C4" stroke-opacity="0.7" /><path d="M133.692 1.67441L22.0521 132.64L131.396 254.844L241.145 129.359L133.692 1.67441Z" fill="url(#paint16_linear)" fill-opacity="0.2" />
        <defs>
          <linearGradient
            id="paint14_linear"
            x1="172.327" y1="317.613" x2="69.4698" y2="358.679" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#6BE3B1" />
          </linearGradient>
          <linearGradient
            id="paint15_linear"
            x1="308.553" y1="348.83" x2="249.453" y2="372.498" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#0B8FC7" />
            <stop offset="1" stop-color="#8280F8" />
          </linearGradient>
          <linearGradient
            id="paint16_linear"
            x1="189.38" y1="149.284" x2="54.9789" y2="74.2293" gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3DB7EB" />
            <stop offset="1" stop-color="#8280F8" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingBackground',
};
</script>

<style scoped>
  .background,
  .figure-1,
  .figure-2,
  .figure-3,
  .figure-4 {
    position: absolute;
    z-index: 1;
  }
  .background {
    width: 100%;
    height: auto;
    left: 0;
    top: 0;
    overflow: hidden;
  }

  .background svg {
    position: relative;
    left: 50vw;
    transform: translateX(-50%);
  }
  .figure-1,
  .figure-3 {
    left: 0;
  }
  .figure-2,
  .figure-4 {
    right: 0;
  }
  .figure-1 {
    bottom: 220px;
  }
  .figure-2 {
    bottom: 273px;
  }
  .figure-3 {
    bottom: 1400px;
  }
  .figure-4 {
    bottom: 2200px;
  }

  .ipad-bg {
    width: 100%;
    padding-top: 131.515625%;
    background: linear-gradient(80.82deg, #0161A7 10.58%, #00B9F3 109.48%);
  }

  .ipad-bg svg {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: -1px;
    transform: none;
  }
</style>
